import { REACT_QUERY_RETRIES_EXHAUSTED_ERROR_NAME } from './newRelic';
import { trackNRError } from '../utils/newRelicTracker';

const MAX_FAILURES = 2;

/**
 * Default retry delay is set to double (starting at 1000ms) with each attempt, but not exceed 30 seconds
 * Ref: https://react-query.tanstack.com/guides/query-retries#retry-delay
 * @param {*} failureCount query failure count
 * @param {*} error the error thrown by query api
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const retryHandler = (failureCount: number, error: any) => {
  // Whether this type of error is retryable is determined by observableFetchCLient.
  // Defaulted to false in case API failed to triage error response code.
  const errorShouldBeRetryable = error?.isRetryable || false;
  const failureCountExceedsThreshold = failureCount >= MAX_FAILURES;
  if (failureCountExceedsThreshold && errorShouldBeRetryable) {
    // If an error reaches its allowed retry limit, create a NR event here.
    trackNRError(
      error,
      { retryFailureCount: `${failureCount}/${MAX_FAILURES}` },
      REACT_QUERY_RETRIES_EXHAUSTED_ERROR_NAME
    );
  }
  return !failureCountExceedsThreshold && errorShouldBeRetryable;
};

export const QUERY_DEFAULT_OPTIONS = {
  queries: {
    retry: retryHandler, // retry when certain types of error occur
    staleTime: 30 * 60 * 1000, // 30 minutes stale time
    refetchOnWindowFocus: false, // no unscheduled refetchs
    cacheTime: 60 * 60 * 1000, // 60 minutes cache time
  },
};
